// To parse this data:
//
//   import { Convert, CreateMemberRequest } from "./file";
//
//   const createMemberRequest = Convert.toCreateMemberRequest(json);

import { DataTableEntry } from '../DataTableEntry';
import { ExtraClientDetails } from '../data-tables/ExtraClientDetails';
import { IntegrationSteps } from '../IntegrationSteps';

export type CreateMemberRequest = {
	address?: Address[];
	familyMembers?: FamilyMember[];
	datatables?: DataTableEntry<ExtraClientDetails | IntegrationSteps | any>[];
	officeId?: number;
	staffId?: number;
	legalFormId?: number;
	clientClassificationId?: number;
	genderId?: number;
	clientTypeId?: number;
	firstname?: string;
	middlename?: string;
	lastname?: string;
	mobileNo?: string;
	externalId?: string;
	active?: boolean;
	locale?: string;
	dateFormat?: string;
	activationDate?: string;
	submittedOnDate?: string;
	dateOfBirth?: string;
	savingsProductId?: string | number;
};

export interface Address {
	countryId?: number;
	stateProvinceId?: number;
	addressTypeId?: number;
	addressLine1?: string;
	addressLine2?: string;
	addressLine3?: string;
	postalCode?: string;
	city?: string;
}

export interface FamilyMember {
	relationshipId?: number;
	firstName?: string;
	middleName?: string;
	lastName?: string;
	age?: string;
	isDependent?: boolean;
	genderId?: number;
	professionId?: number;
	maritalStatusId?: number;
	dateOfBirth?: string;
	locale?: string;
	dateFormat?: string;
}

// Converts JSON strings to/from your types
export class ConvertCreateMemberRequest {
	public static toCreateMemberRequest(json: string): CreateMemberRequest {
		return JSON.parse(JSON.stringify(json));
	}

	public static createMemberRequestToJson(value: CreateMemberRequest): string {
		return JSON.stringify(value);
	}
}
